import { AjaxClient } from "app/common/ajax";
import { IGame } from "app/game/interfaces";
import { tt_icon } from "app/common/tooltip";
import { ucfirst } from "app/common/text";
import * as $ from "jquery";

export function verifyGame(jqDescriptor: string, callback: (game: IGame) => void, expectedStatuses = [1, 2]) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const ajaxClient = (window as any).ajaxClient as AjaxClient;

    $(jqDescriptor).each((i, elmt) => {
        $(elmt).blur(async (evt) => {
            const inputJqEl = $(evt.currentTarget);

            if (!inputJqEl.val()) {
                return;
            }

            inputJqEl.parent().children('.input-status-icon').remove();
            inputJqEl.parent().append('<i class="fa fa-spinner fa-pulse input-status-icon"></i>');

            let result: IGame;
            try {
                result = await ajaxClient.call<IGame>(`/api/game/${inputJqEl.val() as string}`);
            } catch (e) {
                const textStatus = (e as JQueryXHR).statusText;
                const me = inputJqEl.parent();
                me.removeClass('form-error form-warning form-success');
                me.children('.input-status-icon').remove();

                me.addClass('form-error');
                me.append(tt_icon('close', 'Error: ' + textStatus, false, ['input-status-icon']));
                return;
            }

            const me = inputJqEl.parent();
            me.removeClass('form-error form-warning form-success');
            me.children('.input-status-icon').remove();

            if (expectedStatuses != null && expectedStatuses.indexOf(result.status) < 0) {
                me.addClass('form-warning');
                me.append(tt_icon('warning',
                    'The game exists, but using this tool will not do anything.', false, ['input-status-icon']));
            } else {
                me.addClass('form-success');
                me.append(tt_icon('check',
                    'This works, well done! Here\'s a ' + randomThing(), false, ['input-status-icon']));
            }

            if (callback != null) {
                callback(result);
            }
        });
        $(elmt).blur();
    });
}

function randomThing(): string {
    const choices = [
        { word: 'lemon', icon: 'lemon-o' },
        { word: 'spoon', icon: 'spoon' },
        { word: 'high five', icon: 'hand-paper-o' },
        { word: 'high five', icon: 'paw' },
        { word: 'thumbs up', icon: 'thumbs-o-up' },
        { word: 'dollar for your trouble', icon: 'money' }
    ];

    const obj = choices[Math.floor(Math.random() * choices.length)];

    return `${obj.word}: <i class="fa fa-${obj.icon}"></i>`;
}

export function populateWithPlayers(jqDescriptor: string, game: IGame) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const playercolors = (window as any).playercolors as Record<number, string>;

    $(jqDescriptor).children('option').remove();

    for (let i = 1; i <= Object.keys(game.playerList).length; i++) {
        const p = game.playerList[i];
        $(jqDescriptor).append(`<option value="${p.user_id}">${p.username} (${playercolors[p.color]})</option>`);
    }
}

export function populateWithAvailableColors(jqDescriptor: string) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const playercolors = (window as any).playercolors as Record<number, string>;

    $(jqDescriptor).children('option').remove();

    for (let i = 1; i < Object.keys(playercolors).length; i++) { // Skip neutral
        $(jqDescriptor).append(`<option value="${i}">${ucfirst(playercolors[i])}</option>`);
    }
}
